module.exports = __webpack_public_path__ + "fonts/KaTeX_Fraktur-Bold.354501b.woff";